import { render, staticRenderFns } from "./ProductGroupDialog.vue?vue&type=template&id=39022d7a"
import script from "./ProductGroupDialog.vue?vue&type=script&lang=js"
export * from "./ProductGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports